const initOrderPrice = () => {
  document.querySelectorAll('[data-price]').forEach((card) => {
    const input = card.querySelector('[data-quantity-input]');
    const total = card.querySelector('[data-total-price]');
    const price = Number(card.dataset.price);

    if (!input || !total || Number.isNaN(price)) {
      return;
    }

    const updateTotal = () => {
      const quantity = Number.parseInt(input.value, 10) || 0;
      total.textContent = (price * quantity).toLocaleString('ru-RU');
    };

    input.addEventListener('input', updateTotal);
    input.addEventListener('change', updateTotal);
    updateTotal();
  });
};

export {initOrderPrice};
